import { checkAuthentication } from './middleware';

export const reportRoutes = [
    {
        path: '/reports/invoice',
        name: 'ReportInvoice',
        component:  () => import(/* webpackChunkName: "report-route" */ '../views/reports/ReportInvoice'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/reports/daily',
        name: 'DailyReport',
        component:  () => import(/* webpackChunkName: "report-route" */ '../views/reports/DailyReport'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/reports/master',
        name: 'MasterReport',
        component:  () => import(/* webpackChunkName: "report-route" */ '../views/reports/MasterReport'),
        beforeEnter: checkAuthentication
    },
    {
        path: '/reports/downloads',
        name: 'DownloadList',
        component:  () => import(/* webpackChunkName: "report-route" */ '../views/reports/DownloadList'),
        beforeEnter: checkAuthentication
    }

]